var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"fm-table-row",class:{
  'fm-table-row-active': _vm.isActive,
  'fm-table-row-resize': _vm.resize
},style:(_vm.style),on:{"click":_vm.onClick,"dblclick":_vm.onDbclick,"mouseenter":_vm.onMouseenter,"mouseleave":_vm.onMouseleave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }